import React from "react";
import { useState, useEffect } from "react";
// import axios from "axios";
import "./Myorders.css";
import CakeOCard from "./ordercards/CakeOCard";

import { toast } from "react-toastify";
import CupCakeOCard from "./ordercards/CupCakeOCard";
import Doughnuts from "./ordercards/Doughnuts";
import { axiosInstance } from "../config";

const Myorders = () => {
  const [ordertype, setOrdertype] = useState({ type: "" });
  const [cakes, setCakes] = useState();
  const [cupCake, setCupCake] = useState({});
  const [doughnut, setDoughnut] = useState({});

  useEffect(() => {
    try {
      const fetchCake = async () => {
        const orderdata = await axiosInstance.get("/api/mymy");
        setCakes(orderdata.data.allcake);
        setCupCake(orderdata.data.allcupcake);
        setDoughnut(orderdata.data.alldoughnut);
      };
      fetchCake();
    } catch (err) {
      toast.error(err.response.data);
    }
  }, []);

  //
  const handleSubmit = (e) => {
    setOrdertype({ type: e.target.value });
  };
  //

  const orderRender = () => {
    if (ordertype.type === "cake") {
      return <CakeOCard />;
    } else if (ordertype.type === "cupcake") {
      return <CupCakeOCard />;
    } else if (ordertype.type === "doughnut") {
      return <Doughnuts />;
    } else {
      return (
        <div className="no-order">
          <h3 className="sub-body-text">Select Any Order</h3>
        </div>
      );
    }
  };

  //
  console.log("cc", cakes);
  console.log(cupCake);
  console.log(doughnut);
  return (
    <div className="o-main">
      <div>
        <h1 className="o-main-heading">Orders</h1>
      </div>
      <div className="o-all-buttons">
        <button className="o-button" value="cake" onClick={handleSubmit}>
          View Cakes Only
        </button>
        <button className="o-button" value="cupcake" onClick={handleSubmit}>
          View CupCakes Only
        </button>
        <button className="o-button" value="doughnut" onClick={handleSubmit}>
          View Doughnut Only
        </button>
      </div>
      <div className="o-display">{orderRender()}</div>
    </div>
  );
};

export default Myorders;
